import React from "react"
import ReactGA from 'react-ga'

import jptiCta from './jpti_CTA-Workforce-080725.png'

export const NextStepsPage = () => {
    return (
        <>
            <h2>Your Next Steps to Finding Fulfillment</h2>
            <p>
                <strong style={{fontWeight: 800}}>Step 1:</strong> Together with your managers, figure out which of the skills you currently
                have are used in each of the job functions that are your Job Passion Types&trade;. Going forward, you
                should try to use those skills as much as possible and stay away from the ones you don't like. Also identify other skills you
                could learn that would help you excel even more when doing work in your Job Passion Types&trade;. Doing this will provide you  with an
                arsenal of passion-based skills that you can count on to give you enjoyment at work. 
            </p>
            <p>
                <strong style={{fontWeight: 800}}>Step 2:</strong> Talk to your managers about how to incorporate as many of your Job Passion
                Types as possible into your role. If you can be doing work that involves your Job Passion Types&trade; at
                least 65% of the time, you will feel more passionately engaged. If your employer can't make these
                changes to your job description, perhaps they can help you transition into other roles within the
                company that would be a better fit for your Job Passion Types&trade;.
            </p>
            <p>
                <strong style={{fontWeight: 800}}>Step 3:</strong> Have an open and honest discussion with your managers and teams about what
                values are most important to you and gain clarity on how they align with the company's culture and
                objectives. Achieving alignment between the values that are most important to you and what your
                company values doesn't mean everything has to match up perfectly. Instead, it's more about
                understanding where significant overlaps exist and where differences can be respected or even
                leveraged for mutually beneficial growth. 
            </p>
            <p>
                <strong style={{fontWeight: 800}}>Step 4:</strong> Work with your managers to find projects, teams, or roles within your
                organization that resonate with your values. This alignment can provide a more fulfilling and
                engaging work experience that benefits both you and the company.
            </p>
            <div style={{marginTop: "50px", marginBottom: "50px"}} className="text-center">
            <ReactGA.OutboundLink
                eventLabel="survey"
                to="https://getformly.app/nmBaUL"
                target="_blank"
            >
                <img className="d-block w-100" src={jptiCta} alt="Feedback" />
            </ReactGA.OutboundLink>
            </div>
        </>
    )
}